import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth.store';

export const Route = createFileRoute('/_dashboard/dashboard/settings/logout')({
  // Run logout before any component renders so the dashboard layout (Sidebar,
  // Header) never appears — useEffect fires after paint, causing a visible flash.
  beforeLoad: () => {
    useAuthStore.getState().logout();
    throw redirect({ to: '/login', replace: true });
  },
  component: () => null,
});
